module.exports = __webpack_public_path__ + "img/IMG_8673_L_Black_MockedUp.f3b702cd.jpg";